var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0286 27.4374C23.5475 26.9161 23.0184 26.4186 22.4652 25.9684L19.627 29.3329C20.2764 29.8542 20.8777 30.4702 21.3828 31.1336L21.6233 31.4417L26.5782 37.839L30.619 35.8487L24.9186 28.4799C24.6299 28.1245 24.3413 27.7691 24.0286 27.4374Z",
    fill: "url(#paint0_radial_5295_318)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2325 22.4617C10.7755 22.5091 10.3185 22.5565 9.8615 22.6276L0.577148 24.1677C0.913887 25.5182 1.41899 26.8688 2.06842 28.1719C2.09247 28.2193 2.11652 28.2904 2.14058 28.3378L10.1982 26.9872L10.5831 26.9161C11.4249 26.774 12.2668 26.7266 13.1086 26.774L13.3732 22.3906C12.6757 22.3906 11.9541 22.3906 11.2325 22.4617Z",
    fill: "url(#paint1_radial_5295_318)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7276 19.1209C11.4252 18.9788 12.1227 18.7655 12.8202 18.5286L11.2808 14.4296C10.4871 14.7139 9.64526 14.9271 8.80341 15.0219L8.41857 15.0456L0.312803 16.0644C0.048223 17.5335 -0.0479879 19.0262 0.0241703 20.5189L9.35663 19.3579C9.81363 19.2868 10.2706 19.2157 10.7276 19.1209Z",
    fill: "url(#paint2_radial_5295_318)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5033 10.6859C21.6957 10.2831 21.8881 9.85662 22.0324 9.43013L25.3036 0.758202C23.8605 0.355407 22.3692 0.0947752 20.8539 0L18.0156 7.53463L17.8713 7.89004C17.5827 8.67193 17.1979 9.43013 16.7168 10.1173L20.445 12.534C20.8539 11.9417 21.1906 11.3256 21.5033 10.6859Z",
    fill: "url(#paint3_linear_5295_318)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7024 11.918C24.4859 12.6051 24.3175 13.2922 24.1973 13.9794L28.5749 14.7139C28.7192 13.8846 28.9597 13.079 29.2724 12.3208L29.4167 11.9654L32.5676 4.54923L28.8154 2.10876L25.1834 10.6622C24.991 11.065 24.8467 11.4915 24.7024 11.918Z",
    fill: "url(#paint4_linear_5295_318)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0286 27.4375C23.5475 26.9163 23.0184 26.4187 22.4652 25.9685L19.627 29.333C20.2764 29.8543 20.8777 30.4703 21.3828 31.1338L21.6233 31.4418L26.5782 37.8391L30.619 35.8488L24.9186 28.48C24.6299 28.1246 24.3413 27.7692 24.0286 27.4375Z",
    fill: "url(#paint5_linear_5295_318)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2205 23.9308L30.98 23.6228C30.4508 22.983 29.9698 22.2722 29.5849 21.5377L25.6162 23.5043C25.9289 24.144 26.3137 24.7601 26.7226 25.3524C26.9872 25.7315 27.2518 26.0869 27.5645 26.4423L33.5536 33.5979L36.4399 30.1623L31.2205 23.9308Z",
    fill: "url(#paint6_linear_5295_318)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4421 24.997C15.9953 21.7746 15.4902 18.4101 14.0229 15.4958C13.4938 14.4533 12.8444 13.4581 12.0987 12.5577L6.08554 5.40222C4.97912 6.44475 4.01701 7.60575 3.19922 8.83782L8.41866 15.0456L8.65919 15.3536C9.18835 15.9934 9.6694 16.7042 10.0542 17.4387C10.3188 17.9836 10.5594 18.5286 10.7277 19.1209C11.0645 20.1872 11.2328 21.3245 11.2328 22.4618C11.2328 23.0541 11.1847 23.6701 11.0645 24.2625C10.9201 25.0918 10.6796 25.8974 10.3669 26.6556L10.2226 27.011L7.07171 34.4271C8.22624 35.3986 9.50103 36.2279 10.848 36.8913L14.4799 28.3378C14.9129 27.2716 15.2496 26.1343 15.4421 24.997Z",
    fill: "#FF8D25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1738 13.0316C19.7234 15.1166 22.9464 16.3724 26.2416 16.562C27.0835 16.6094 27.9253 16.5857 28.7672 16.5146C29.1039 16.4909 29.4406 16.4435 29.7774 16.3724L39.0617 14.8323L37.4743 10.6622L29.4166 12.0128L29.0318 12.0838C28.1899 12.226 27.3481 12.2734 26.5062 12.226C25.9049 12.1786 25.2795 12.1075 24.7023 11.9654C23.5958 11.7047 22.5135 11.3019 21.5273 10.7333C20.9981 10.4253 20.493 10.0936 20.036 9.69077C19.3866 9.14581 18.7853 8.55346 18.2802 7.89004L18.0397 7.58202L13.0848 1.18469C12.3873 1.44532 11.6897 1.72965 11.0163 2.06136C10.3187 2.39308 9.66932 2.77218 9.04395 3.17497L14.7444 10.5437C15.442 11.4204 16.2598 12.2734 17.1738 13.0316Z",
    fill: "#FF8D25"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.615 18.4575L30.2825 19.6185C29.1039 19.7607 27.9494 20.045 26.843 20.4478C23.7402 21.5851 21.0222 23.6938 19.1942 26.4186C18.5448 27.3901 17.9916 28.4326 17.5827 29.5462L14.3115 38.2418L18.7853 38.9764L21.6236 31.4417L21.7679 31.0863C22.0565 30.3044 22.4413 29.5462 22.9224 28.8591C23.2591 28.3615 23.644 27.8877 24.0529 27.4375C24.8226 26.6082 25.7366 25.8974 26.7468 25.3524C27.2759 25.0444 27.8292 24.8075 28.4064 24.5942C29.2002 24.3099 30.0179 24.0966 30.8838 24.0019L31.2687 23.9545L39.3745 22.9356C39.5909 21.4666 39.6871 19.9739 39.615 18.4575Z",
    fill: "#FF8D25"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5295_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9546 19.9324) scale(19.7593 19.4645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FC7526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5295_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2742 19.5879) scale(11.5208 11.3489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5295_318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2744 19.5879) scale(11.5208 11.3489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5295_318",
    x1: 18.7384,
    y1: 11.9189,
    x2: 21.409,
    y2: 4.15578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5295_318",
    x1: 26.4002,
    y1: 14.5546,
    x2: 29.0708,
    y2: 6.79123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC631C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5295_318",
    x1: 21.9042,
    y1: 28.4372,
    x2: 26.5706,
    y2: 34.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F46225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FA7E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#FD8F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5295_318",
    x1: 28.3984,
    y1: 23.7306,
    x2: 32.9875,
    y2: 29.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#F46225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FA7E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#FD8F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.61ac94b606f85587fa9a9b47983cf313.svg";
export { ForwardRef as ReactComponent };